import React, { Component } from "react"
import { searchTableFilter } from "../Tree/Utils.js"
import { table_box_element } from './ParentDiploma'

//import SearchBar from '../Tree/components/SearchBar.jsx'
//import { EditableCell } from '../TableList/EditableCell'
import { ProductRow } from '../TableList/ProductRow'
// input (props) 
//      tableTitle={"תוכנית עבודה"}
//      familyCode - TBD
// Resources: see import above

// TODO: get data from DB && Update to DB

export const  EmployBoz_microLegend = {
    "employ_place": "מקום עבודה ומעסיק",
    "employ_role": "תפקיד",
    "employ_from_date": "ת. התחלה",
    "employ_to_date": "ת. סיום",
    "employ_vetek": "וותק",
    "employ_skills": "כישורים נדרשים",
    "employ_salary": "רמת שכר"
}

export class ParentEmployBoz extends Component {

    constructor(props) {
      super(props)
      this.state = { products: this.props.data }
      this.onSaveTable = this.onSaveTable.bind(this)
    }
    
    handleRowDel(product) {
      const {products} = this.state
      var index = products.indexOf(product)
      if (index === -1)
        return console.log("FamilyRights productnot found", product)

      var array = [...products]
      //this.state.products.splice(index, 1)
      array.splice(index, 1)
      this.setState({products:array})
    }
    /*
    handleRowDel(product) {
      var index = this.state.products.indexOf(product)
      this.state.products.splice(index, 1)
      this.setState(this.state.products)
    }*/
  
    handleAddEvent(evt) {
      evt.preventDefault()
      var id = (+ new Date() + Math.floor(Math.random() * 999999)).toString(36);
      //let d = digmaDate(Date())
      var product = {
        id: id,
        "employ_place": "",
        "employ_role": "",
        "employ_from_date": "",
        "employ_to_date": "",
        "employ_vetek": "",
        "employ_skills": "",
        "employ_salary": ""
      }
      let newP = (this.state.products === undefined || this.state.products === false) ? [] : Object.assign(this.state.products)
      newP.unshift(product)
      this.setState({products: newP})
      //this.state.products.unshift(product)
      //this.setState(this.state.products)
    }
  
    handleProductTable(evt) {
      evt.preventDefault()

      var item = {
        //id: evt.target.id,
        name: evt.target.name,
        value: evt.target.value,
        nid: evt.target.getAttribute('data-id')
    }
        // console.log("pRODUCT-EVT", item);

        var products = this.state.products.slice();
        // console.log("products-EVT", products);

        var newProducts = products.map(function(product) {
  
            for (var key in product) {
                if (key === item.name && product.id === item.nid) {
                    product[key] = item.value
                }
            }
            return product
        })
        this.setState({products:newProducts})
    }

    // update data base
    onSaveTable(evt) {
      evt.preventDefault()
      const { save2DB, subTableId, memberPostId } = this.props
      //console.log("Family General save table: products", this.state.products)
      console.log("hEALTH SAVE PROPS", this.props)
   
      save2DB(memberPostId, this.state.products, subTableId, "table" )
    }
    render() {
      const {tableTitle} = this.props
      // const { data } = this.props
      // console.log("Family general data", data)
      //console.log("OLD meeting data", this.state.products)
      
      return (
          <ProductTable 
            onProductTableUpdate={this.handleProductTable.bind(this)}
            onSaveTable={this.onSaveTable} 
            headerColumns = {["employ_place","employ_role","employ_from_date","employ_to_date",
                                        "employ_vetek","employ_skills", "employ_salary"]}
            tableTitle = {tableTitle} // "סיכומי מפגשים"
            onRowAdd={this.handleAddEvent.bind(this)} 
            onRowDel={this.handleRowDel.bind(this)} 
            products={this.state.products} 
          />
      )
    }
  }
  /*   class SearchBar extends Component { moved to file */
   
  class ProductTable extends Component {
    constructor(props){
        super(props)
        this.state={
            filterText : ""
        }
        this.handleUserInput = this.handleUserInput.bind(this)
    }
    
    handleUserInput(filterText) {
        this.setState({filterText: filterText});
    }
    render() {
      const { onProductTableUpdate, onRowDel, onRowAdd, headerColumns, products, tableTitle, onSaveTable } = this.props
      const { filterText } = this.state
      var product = (products === undefined || products === false) ? "" : products.map(function(product) {
          // check on all relevant data fields
      if (!searchTableFilter(product, filterText))
            return null;
       var rowKey=0         
       const cellData=[{
        type: "text",
        name: "employ_place",
        value: product.employ_place,
        id: product.id,
        style: {width: "200px"},
        edit: true
      },{
        type: "text",
        name: "employ_role",
        value: product.employ_role,
        id: product.id,
        style: {width: "160px"},
        edit: true
      },{
        type: "text",
        name: "employ_from_date",
        value: product.employ_from_date,
        id: product.id,
        style: {width: "100px"},
        placeholder: 'dd/mm/yyyy',
        edit: true
      },{
        type: "text",
        name: "employ_to_date",
        value: product.employ_to_date,
        id: product.id,
        style: {width: "100px"},
        placeholder: 'dd/mm/yyyy',
        edit: true
      },{
        type: "text",
        name: "employ_vetek",
        value: product.employ_vetek,
        id: product.id,
        style: {width: "100px"},
        edit: true
      },{
        type: "textarea",
        name: "employ_skills",
        value: product.employ_skills,
        id: product.id,
        style: {width: "150px"},
        edit: true
      },{
        type: "text",
        name: "employ_salary",
        value: product.employ_salary,
        id: product.id,
        style: {width: "100px"},
        edit: true
      }] 
      
          
        return (
          <ProductRow 
            onProductTableUpdate={onProductTableUpdate} 
            product={product} 
            onDelEvent={onRowDel.bind(this)} 
            key={product.id || rowKey++}
            cd={cellData}
            />)
      })
      return table_box_element(tableTitle, products, product, onRowAdd, this.state.filterText, 
        this.handleUserInput, onSaveTable, headerColumns, EmployBoz_microLegend)
    
    }
  }
 